<div class="cv-studio-pane-header">
  <h2>
    @if (isReplaceMode) {
      <span class="hint-tip" tabindex="0" [nbTooltip]="'cv_studio.replace_mode_hint' | translate" [attr.aria-description]="'cv_studio.replace_mode_hint' | translate">{{ 'cv_studio.replace_mode_title' | translate:{ value: replaceTemplateName || '' } }}</span>
    } @else {
      {{ 'cv_templates.upload_button' | translate }}
    }
  </h2>
</div>

<form [formGroup]="form" class="cv-studio-upload-form">
  <label class="cv-studio-upload-field">
    {{ 'cv_templates.name_label' | translate }}
    <input nbInput fullWidth formControlName="name" maxlength="80" />
    <small class="text-danger" *ngIf="fieldErrors['name']">{{ fieldErrors['name'] }}</small>
  </label>

  <div class="cv-studio-upload-field">
    {{ 'cv_templates.base_layout_label' | translate }}
    @if (showLayoutDropdown) {
      <nb-select formControlName="base_layout_id" fullWidth>
        <nb-option *ngFor="let l of baseLayouts" [value]="l.id">{{ l.name }}</nb-option>
      </nb-select>
      <small class="text-danger" *ngIf="fieldErrors['base_layout_id']">{{ fieldErrors['base_layout_id'] }}</small>
      <a href="javascript:void(0)"
         class="cv-studio-text-link"
         [class.disabled]="!form.value.base_layout_id"
         [nbTooltip]="'cv_templates.download_base_hint' | translate"
         (click)="downloadBaseSample()">
        {{ 'cv_templates.download_base_label' | translate }}
      </a>
    } @else {
      <div class="cv-studio-base-chip">
        <span>{{ 'cv_studio.based_on_chip' | translate:{ value: baseLayoutName(form.value.base_layout_id) } }}</span>
        @if (!isReplaceMode) {
          <a href="javascript:void(0)" class="cv-studio-text-link" (click)="changeBase()">
            {{ 'cv_studio.change_base_link' | translate }}
          </a>
        }
      </div>
    }
  </div>

  <label class="cv-studio-upload-field">
    {{ 'cv_templates.first_page_label' | translate }}
    <div class="cv-studio-file-drop"
         [class.dragging]="dragSlot === 'first'"
         (dragover)="onDragOver($event, 'first')"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event, 'first')">
      <input type="file"
             accept="application/pdf,image/png,image/jpeg"
             (change)="onFirstPagePicked($event)" />
      <span *ngIf="!firstPageFile" class="hint">Drop a file here or click to browse</span>
      <span *ngIf="firstPageFile" class="filename">{{ firstPageFile.name }}</span>
    </div>
    <small class="text-danger" *ngIf="fieldErrors['first_page_file']">{{ fieldErrors['first_page_file'] }}</small>
  </label>

  <label class="cv-studio-upload-field">
    {{ 'cv_templates.continuation_label' | translate }}
    <div class="cv-studio-file-drop"
         [class.dragging]="dragSlot === 'continuation'"
         (dragover)="onDragOver($event, 'continuation')"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event, 'continuation')">
      <input type="file"
             accept="application/pdf,image/png,image/jpeg"
             (change)="onContinuationPicked($event)" />
      <span *ngIf="!continuationFile" class="hint">Drop a file here or click to browse</span>
      <span *ngIf="continuationFile" class="filename">{{ continuationFile.name }}</span>
    </div>
    <small class="text-danger" *ngIf="fieldErrors['continuation_file']">{{ fieldErrors['continuation_file'] }}</small>
  </label>
</form>

<div class="text-danger cv-studio-upload-file-error" *ngIf="fileError">{{ fileError }}</div>

<div class="cv-studio-upload-actions">
  <button nbButton ghost (click)="cancel()" [disabled]="submitting">Cancel</button>
  <button nbButton status="primary" (click)="submit()" [disabled]="!canSubmit">
    <nb-icon *ngIf="submitting" icon="loader-outline"></nb-icon>
    @if (isReplaceMode) { Save } @else { Upload }
  </button>
</div>
